import { IsoString } from 'models';
import moment from 'moment';
import { ISO_DATE_FORMAT } from 'utils';
import {
	ISlidersPayload,
	IReminderFrequencyTypes,
	IRepetitiveTypes,
	IRoundFrequency,
	ISurveyDurationTypes,
	ISurveyInterfaceTypes,
	ISurveyRoundDurationTypes,
	ITemplateSchedulingData,
} from 'modules/admin-panel/pages/templates/models';

interface ITemplateSchedulingPayload {
	name: string;
	clientId: string;
	roles: number[];
	offices: string[];
	sendRespondentCount: number;
	isRepeatable: boolean;
	startDate: IsoString;
	surveyDuration: ISurveyDurationTypes;
	surveyRoundDuration: number;
	frequency: IRoundFrequency;
	sendingTime: string;
	templateId: number;
	services: number[];
	surveyInterface: ISurveyInterfaceTypes;
	questionId: number;
	isDailyReminders: boolean;
	workStyleSlidersExtremes?: ISlidersPayload;
	performanceSlidersExtremes?: ISlidersPayload;
	isQuick: boolean;
	scalePoints?: number;
	maxOfNegativeRange?: number;
	maxOfNeutralRange?: number;
}

export function mapSchedulingData(
	data: ITemplateSchedulingData,
): ITemplateSchedulingPayload {
	const {
		schedulingFormData: {
			surveyName,
			clientId,
			offices,
			sendRespondentCount,
			repetitiveType,
			startDate,
			surveyDuration,
			surveyRoundDuration,
			roundFrequency,
			sendingTime,
			remindersFrequency,
		},
		appearanceFormData: { surveyRoles, surveyInterface, questionId },
		servicesList,
		templateId,
		workStyleSlidersExtremes,
		performanceSlidersExtremes,
		isQuick,
		scalePoints,
		maxOfNegativeRange,
		maxOfNeutralRange,
	} = data;

	return {
		name: surveyName as string,
		clientId: clientId as string,
		roles: surveyRoles as number[],
		offices: offices as string[],
		sendRespondentCount: parseInt(sendRespondentCount || '0', 10),
		isRepeatable: repetitiveType === IRepetitiveTypes.repetitive,
		startDate: moment(startDate).format(ISO_DATE_FORMAT),
		surveyDuration: surveyDuration as ISurveyDurationTypes,
		surveyRoundDuration:
			surveyRoundDuration === ISurveyRoundDurationTypes.ONE_WEEK ? 1 : 2,
		frequency: roundFrequency as IRoundFrequency,
		sendingTime: moment(sendingTime).format('HH:mm'),
		templateId,
		services: servicesList,
		surveyInterface: surveyInterface as ISurveyInterfaceTypes,
		questionId: questionId as number,
		isDailyReminders: remindersFrequency === IReminderFrequencyTypes.eachDay,
		workStyleSlidersExtremes,
		performanceSlidersExtremes,
		isQuick,
		scalePoints,
		maxOfNegativeRange,
		maxOfNeutralRange,
	};
}
